import { useQuery } from '@tanstack/react-query';
import { getApiClient } from '../api/apiClient';

const apiClient = getApiClient('kisanVani');

export function buildAdminCommentsParams({
  status, hasReplies, fromDate, toDate, page = 1, limit = 20, minComments, maxComments, sortBy,
}) {
  const params = new URLSearchParams({ page, limit });
  if (status) params.set('status', status);
  if (hasReplies === true) params.set('hasReplies', 'true');
  else if (hasReplies === false) params.set('hasReplies', 'false');
  if (fromDate) params.set('fromDate', fromDate);
  if (toDate) params.set('toDate', toDate);
  if (minComments !== undefined && minComments !== null) params.set('minComments', minComments);
  if (maxComments !== undefined && maxComments !== null) params.set('maxComments', maxComments);
  if (sortBy) params.set('sortBy', sortBy);
  return params;
}

export function useAdminComments({
  status, hasReplies, fromDate, toDate, page = 1, limit = 20, minComments, maxComments, sortBy,
}) {
  return useQuery({
    queryKey: ['admin-comments', status, hasReplies, fromDate, toDate, page, limit, minComments, maxComments, sortBy],
    queryFn: async () => {
      const params = buildAdminCommentsParams({
        status, hasReplies, fromDate, toDate, page, limit, minComments, maxComments, sortBy,
      });
      const { data } = await apiClient.get(`/approve/comments?${params}`);
      return data?.data ?? [];
    },
    staleTime: 30 * 1000,
  });
}
